import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { MobileConsultationView } from '../types/consultationPage.types';
import styles from '../styles.module.scss';

type Props = {
  mobileView: MobileConsultationView;
  setMobileView: (view: MobileConsultationView) => void;
};

const MobileBottomNav = ({ mobileView, setMobileView }: Props): JSX.Element => {
  return (
    <div className={styles.mobileBottomNav}>
      <button
        type="button"
        className={`${styles.mobileBottomNavItem} ${mobileView === 'case' ? styles.mobileBottomNavItemActive : ''}`}
        onClick={() => setMobileView('case')}
      >
        <DescriptionOutlinedIcon />
        <span>Case</span>
      </button>

      <button
        type="button"
        className={`${styles.mobileBottomNavItem} ${mobileView === 'patient-info' ? styles.mobileBottomNavItemActive : ''}`}
        onClick={() => setMobileView('patient-info')}
      >
        <AccountCircleOutlinedIcon />
        <span>Patient info</span>
      </button>

      <button
        type="button"
        className={`${styles.mobileBottomNavItem} ${mobileView === 'care-team' ? styles.mobileBottomNavItemActive : ''}`}
        onClick={() => setMobileView('care-team')}
      >
        <Groups2OutlinedIcon />
        <span>Care team</span>
      </button>
    </div>
  );
};

export default MobileBottomNav;